// Fargepalett for statuser (board-kolonner). Brukes når man velger farge på en
// status og når tavlevisningen tegner kolonnene (prikk + tonet bakgrunn), som i
// ClickUp.
export const STATUS_COLORS = [
  "#6b7280", // grå
  "#3b82f6", // blå
  "#06b6d4", // cyan
  "#10b981", // grønn
  "#a4e87d", // lysegrønn
  "#e8cb7d", // gul
  "#f97316", // oransje
  "#e88b7d", // korall
  "#ef4444", // rød
  "#8b5cf6", // lilla
  "#ec4899", // rosa
];

export const DEFAULT_STATUS_COLOR = "#6b7280";

// Legg en alfakanal på en #rrggbb-farge slik at vi kan tone bakgrunnen svakt.
export const withAlpha = (hex: string, alpha: number) => {
  const match = /^#?([0-9a-fA-F]{6})$/.exec(hex);
  if (!match) return hex;
  const int = parseInt(match[1], 16);
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const statusColor = (color: string | null | undefined) =>
  color || DEFAULT_STATUS_COLOR;
